import styled from 'styled-components';

export const InputFileMainWrapper = styled.div`
  width: 100%;
  height: 22rem;
  display: block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  > div:nth-of-type(1) {
    box-shadow: none;
  }
`;
